<div class="subject-container" [class.editable]="editable">
  <div *ngIf="editable && editableSubjectValue !== false; else staticSubject" class="editable-subject-container w-100">
    <app-form-control [error]="subjectError$ | async">
      <input
        appFormControlInput
        type="text"
        class="form-control-input text-increased-regular subject-input w-100"
        [ngClass]="subjectControl ? 'static-subject' : ''"
        [placeholder]="'MESSAGES.SUBJECT_PLACEHOLDER' | translate"
        [formControl]="subjectControl"
        data-hj-allow
      />
    </app-form-control>
    <div class="mt-2">
      <ng-container [ngTemplateOutlet]="shipmentLink"></ng-container>
    </div>
  </div>
  <ng-template #staticSubject>
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="static-subject-wrapper">
        <div class="static-subject text-increased-regular" *ngIf="sendBirdChannel" [title]="sendBirdChannel">
          {{ sendBirdChannel }}
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="shipmentLink"></ng-container>
    </div>
  </ng-template>
</div>

<ng-template #shipmentLink>
  <a *ngIf="shipment && shipment?.parentObject !== 'Account'" [routerLink]="shipmentRouterLink" class="text-reduced-bold shipment-title">
    {{ getHyperLinkFromShipment(shipment) }}
    {{ shipment.reference }}
  </a>
</ng-template>
